import React from 'react';

const FeedbackDisplay = ({ message, type = 'info' }) => {
    if (!message) return null;

    const getTypeStyles = () => {
        switch (type) {
            case 'success':
                return {
                    container: 'bg-gradient-to-r from-green-500/20 to-emerald-500/20 border border-green-400/30 text-green-100 shadow-lg shadow-green-500/10',
                    glow: 'shadow-green-400/20'
                };
            case 'error':
                return {
                    container: 'bg-gradient-to-r from-orange-500/20 to-red-500/20 border border-orange-400/30 text-orange-100 shadow-lg shadow-orange-500/10',
                    glow: 'shadow-orange-400/20'
                };
            case 'warning':
                return {
                    container: 'bg-gradient-to-r from-yellow-500/20 to-amber-500/20 border border-yellow-400/30 text-yellow-100 shadow-lg shadow-yellow-500/10',
                    glow: 'shadow-yellow-400/20'
                };
            default:
                return {
                    container: 'bg-gradient-to-r from-blue-500/20 to-cyan-500/20 border border-blue-400/30 text-blue-100 shadow-lg shadow-blue-500/10',
                    glow: 'shadow-blue-400/20'
                };
        }
    };

    const getIcon = () => {
        switch (type) {
            case 'success':
                return '🎉';
            case 'error':
                return '💪';  // Changé pour être plus encourageant
            case 'warning':
                return '🌟';
            default:
                return '💡';
        }
    };

    const styles = getTypeStyles();

    return (
        <div className={`p-6 rounded-2xl ${styles.container} mb-6 transform transition-all duration-300 hover:scale-105 backdrop-blur-sm`}>
            <div className="flex items-center space-x-4">
                <div className={`text-3xl ${styles.glow} transition-all duration-300`}>
                    {getIcon()}
                </div>
                <div className="flex-grow">
                    {typeof message === 'string' ? (
                        <p className="font-semibold text-lg leading-relaxed">{message}</p>
                    ) : (
                        message
                    )}
                </div>
            </div>

            {/* Barre de progression décorative */}
            <div className="mt-4 h-1 bg-white/10 rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-transparent via-white/20 to-transparent animate-pulse"></div>
            </div>
        </div>
    );
};

export default FeedbackDisplay;
